import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

/**
 * Session d'authentification DÉDIÉE au Community Intelligence Dashboard.
 *
 * Cette session est complètement séparée de useUserStore (l'app pool). Elle utilise
 * sa propre clé de stockage (`ci-dashboard-auth`) dans sessionStorage. Se connecter
 * au dashboard n'affecte pas la session pool en cours, et vice-versa.
 *
 * On réutilise en revanche la même RPC `login_user` et les mêmes credentials que
 * l'app principale (pas de duplication de la logique d'authentification).
 */
interface CiAuthState {
  user_id: number | null;
  username: string | null;
  email: string | null;
  loggedInAt: string | null;
  setUser: (u: { user_id: number; username: string; email: string }) => void;
  logout: () => void;
}

export const useCiAuthStore = create<CiAuthState>()(
  persist(
    (set) => ({
      user_id: null,
      username: null,
      email: null,
      loggedInAt: null,
      setUser: ({ user_id, username, email }) =>
        set({ user_id, username, email, loggedInAt: new Date().toISOString() }),
      logout: () => set({ user_id: null, username: null, email: null, loggedInAt: null }),
    }),
    {
      name: 'ci-dashboard-auth',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
